/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Bind } from 'lodash-decorators';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import ds, { media } from 'designsystem';
import styled from 'styled-components';

const Currency = styled.span`
  font-size: ${ds.fs('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: gray;
  
  ${media.tablet`
    font-size: ${ds.fs('m')};
  `}
`;

const Label = styled.label`
  font-size: ${ds.fs('s')};
  font-family: ${ds.get('type.fontFamily.text')};
  text-align: ${({ labelRight }) => (labelRight ? 'end' : 'start')};
  width: 120px;

  ${media.mobile`
    width: 100%;
  `}
`;

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${ds.get('metrics.s')};
  justify-content: ${({ toRight }) => (toRight ? 'flex-end' : 'flex-start')};
`;

const Button = styled.button`
  width: 16px;
  height: 16px;
  border: none;
  background-color: #fff;
  outline: none;
  padding: 0;
  margin: 0 ${ds.get('metrics.xs')};
  cursor: pointer;
  font-size: ${ds.fs('l')};
  font-weight: bold;
  line-height: 0;
  user-select: none;
  
  &:hover {
    opacity: 0.7;
  }
`;

const InputField = styled.input`
  border: none;
  text-align: center;
  font-size: ${ds.fs('m')};
  max-width: ${ds.get('metrics.l')};
  margin: 0;

  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ${media.tablet`
    font-size: ${ds.fs('l')};
    max-width: ${ds.get('metrics.xl')};
  `}
`;

@observer
class CalculatorInput extends Component {
  @Bind
  onInput(e) {
    const {
      valueObservableBox,
      noNegative,
    } = this.props;
    if (!noNegative || (noNegative && e.target.value >= 0)) {
      valueObservableBox.set(parseInt(e.target.value, 10) || 0);
    }
  }

  @Bind
  decrease() {
    const {
      valueObservableBox,
      noNegative,
    } = this.props;
    try {
      const value = parseInt(valueObservableBox.get(), 10);
      if (noNegative && value <= 0) {
        return;
      }
      valueObservableBox.set(value - 1);
    } catch (e) {
      console.error('wrong value in input: ', e);
    }
  }

  @Bind
  increase() {
    const { valueObservableBox } = this.props;
    try {
      valueObservableBox.set(parseInt(valueObservableBox.get(), 10) + 1);
    } catch (e) {
      console.error('wrong value in input: ', e);
    }
  }

  render() {
    const {
      valueObservableBox,
      hasButtons,
      label,
      labelRight,
      currency,
    } = this.props;

    return (
      <Label
        labelRight={labelRight}
      >
        {label}
        <InputGroup
          toRight={currency}
        >
          { hasButtons && (
            <Button
              type="button"
              onClick={this.decrease}
            >
              {'−'}
            </Button>
          )}
          <InputField
            type="number"
            onInput={this.onInput}
            value={valueObservableBox.get()}
          />
          { currency && (
            <Currency>
              {currency}
            </Currency>
          )}
          { hasButtons && (
            <Button
              type="button"
              onClick={this.increase}
            >
              {'+'}
            </Button>
          )}
        </InputGroup>
      </Label>
    );
  }
}

CalculatorInput.defaultProps = {
  hasButtons: false,
  label: '',
  labelRight: false,
  currency: '',
  noNegative: false,
  valueObservableBox: observable.box(0),
};

export default CalculatorInput;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorInputRow/CalculatorInput/index.jsx